import { render, staticRenderFns } from "./CollectionEventDetailsList.vue?vue&type=template&id=5498f7ef&scoped=true&"
import script from "./CollectionEventDetailsList.vue?vue&type=script&lang=ts&"
export * from "./CollectionEventDetailsList.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionEventDetailsList.vue?vue&type=style&index=0&id=5498f7ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5498f7ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCol,VContainer,VList,VListItem,VListItemSubtitle,VListItemTitle,VRow})
